export default function useDisplayMetric(): boolean {
  return global.__AT_DATA__.displayMetric;
}
